import { render } from "./app.vue?vue&type=template&id=683a4570&ts=true"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import "./app.vue?vue&type=style&index=0&id=683a4570&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__